import { render, staticRenderFns } from "./ConfigCategoryScania.vue?vue&type=template&id=d4c5933c&"
import script from "./ConfigCategoryScania.vue?vue&type=script&lang=js&"
export * from "./ConfigCategoryScania.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports